import React, { useState, useEffect, useRef, useContext } from 'react';
import TextInput from '@/components/text-input';

export default function CustomFormEditor(props: any) {

    const [inputErrors, setInputErrors] = useState<any>({});

    console.log('CustomFormEditor: ', props);
    const [subject, setSubject] = useState(props.title);

    const handleSubjectChange = (e: any) => {
        setSubject(e.target.value);
    };

    return (
        <div className="custom-modal-overlay">
            <div className="row">
                <div className="column">
                    <TextInput
                        label="Title your appointment"
                        required={true}
                        type="text"
                        changeHandler={handleSubjectChange}
                        value={subject}
                        error={inputErrors.Subject}
                    />
                </div>
            </div>            
        </div>
    )
};
